import * as React from "react";
import { forwardRef } from "react";
const SvgCheckbox = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.75, y: 0.75, width: 14.5, height: 14.5, rx: 1.25, stroke: "currentColor", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgCheckbox);
export default ForwardRef;
